import React from 'react'
import InputSearch from "./InputSearch"
import DateFilter from "./DateFilter"

function CheckHotlineSearch(props) {
    const {filters, setFiltersState} = props

    const _handleChangeInput = (name, value) => {
        const newState = {
            [name]: value
        }

        setFiltersState(newState)
    }

    return (
        <div className="CallHistoryFilters Filters">
            <div className="itemFilter mb-3">
                <InputSearch
                    label="Tên list check"
                    name="listCheckName"
                    value={filters.listCheckName || ''}
                    onChange={_handleChangeInput}
                />
            </div>
            <div className="itemFilter mb-3">
                <DateFilter
                    label="Ngày tạo (từ)"
                    name="fromListCreatedAt"
                    value={filters.fromListCreatedAt}
                    format="DD/MM/YYYY"
                    showTime={false}
                    onChangeDate={_handleChangeInput}
                />
            </div>
            <div className="itemFilter mb-3">
                <DateFilter
                    label="Ngày tạo (đến)"
                    name="toListCreatedAt"
                    value={filters.toListCreatedAt}
                    format="DD/MM/YYYY"
                    showTime={false}
                    onChangeDate={_handleChangeInput}
                />
            </div>
        </div>
    )
}

export default CheckHotlineSearch
